import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);


const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['./pages/home'], resolve)
    },
    {
      path: '/video',
      name: 'video',
      component: resolve => require(['./pages/video/room'], resolve)
    },
    {
      path: '/rule',
      name: 'rule',
      component: resolve => require(['./pages/rule/rule'], resolve)
    },
    {
      path: '/scan',
      name: 'scan',
      component: resolve => require(['./pages/scan/scan'], resolve)
    },
    {
      path: '/error',
      name: 'error',
      component: resolve => require(['./pages/error/error'], resolve)
    }
  ]
});

router.beforeEach((to, from, next) => {
  console.log(to.matched)
  if (to.matched.length ===0) {  //如果未匹配到路由
    next('/error');   //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
  } else {
    next();    //如果匹配到正确跳转
  }
});

export default router;
